module.exports = __webpack_public_path__ + "img/diesel-dashboard2.9cf8d37c.png";